import getApiUrl from '../configuration/getApiUrl';
import { getSupabaseAccessToken, isSupabaseAuthConfigured } from './supabaseAuth';

let isInstalled = false;

function isApiRequest(input: RequestInfo | URL) {
  const apiBase = new URL(getApiUrl(), window.location.origin);
  const apiPrefix = `${apiBase.pathname.replace(/\/$/, '')}/api/`.replace('//api/', '/api/');
  const requestUrl =
    input instanceof Request
      ? new URL(input.url, window.location.origin)
      : new URL(input.toString(), window.location.origin);

  return requestUrl.origin === apiBase.origin && requestUrl.pathname.startsWith(apiPrefix);
}

export function installApiAuthFetch(): void {
  if (isInstalled || typeof window === 'undefined' || !isSupabaseAuthConfigured()) {
    return;
  }

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    if (!isApiRequest(input)) {
      return originalFetch(input, init);
    }

    const accessToken = await getSupabaseAccessToken();
    if (!accessToken) {
      return originalFetch(input, init);
    }

    const headers = new Headers(input instanceof Request ? input.headers : undefined);
    if (init?.headers) {
      new Headers(init.headers).forEach((value, key) => headers.set(key, value));
    }

    if (!headers.has('Authorization')) {
      headers.set('Authorization', `Bearer ${accessToken}`);
    }

    const nextInit = {
      ...init,
      headers,
    };

    if (input instanceof Request) {
      return originalFetch(new Request(input, nextInit));
    }

    return originalFetch(input, nextInit);
  };

  isInstalled = true;
}
